import { useCreateSignaalGroepFosfor } from "@/lib/queries/config-api/cluster";
import { SignaalgroepFosfor } from "@/lib/types/cluster";
import { Form, Input, Modal } from "antd";
import { useState } from "react";

interface ModalProps {
  visible: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const SignaalFosforModal: React.FunctionComponent<ModalProps> = ({ visible, onClose, onSave }) => {
  const [form] = Form.useForm<SignaalgroepFosfor>();
  const [loading, setLoading] = useState(false);

  const createSignaalFosfor = useCreateSignaalGroepFosfor();

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      createSignaalFosfor.mutate({ ...values }, {
        onSuccess: () => {
          onSave();
        },
        onError: (error) => {
          console.error('Failed to save:', error);
          setLoading(false);
        }
      })

      setLoading(false);
      onSave(); // Notify parent to refresh data
      onClose(); // Close modal
    } catch (error) {
      console.error('Failed to save:', error);
      setLoading(false);
    }
  };

  return (
    <Modal
      title={"Signaalgroep fosfor aanmaken"}
      open={visible}
      onCancel={onClose}
      onOk={handleSave}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="waarde"
          label="Waarde"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}